import {map} from 'lodash';
import {useEffect, useState} from 'react';
import Highcharts from 'highcharts/highstock';
import {Box, Typography} from '@mui/material';
import Mapka from './assets/mapka-port-gdynia-new-clean.png';
// import GaugeChart from './components/GaugeChart/GaugeChart';
import AnalyticChart from './components/AnalyticChart/AnalyticChart';
import DeviceMarker from './components/DeviceMarker/DeviceMarker';
import {BASE_URL, PORT_GDYNIA_MAIN_COLOR} from './utils';


const devicesNames = {
  'GDY_00': '8 - Ul. Rotterdamska 13',
  'GDY20180803320001': '1 - Kapitanat',
  'GDY20180803320002': '2 - Ul. Chrzanowskiego',
  'GDY20180803320003': '3 - Ul. Węglowa',
  'GDY20180803320004': '4 - Nauta',
  'GDY20180803320005': '5 - Dalmor',
  'GDY20181103320006': '6 - Bunkier',
  'GDY_07': '7 - Nab. Indyjskie',

};

const devices = [
  {serialNo: 'GDY_00', name: '8 - Ul. Rotterdamska 13', left: 190, top: 340, labelLeft: 20, labelTop: 20},
  {serialNo: 'GDY20180803320001', name: '1 - Kapitanat', left: 295 + 368 - 20, top: 97 + 90 - 50, labelLeft: -340, labelTop: -205},
  {serialNo: 'GDY20180803320002', name: '2 - Ul. Chrzanowskiego', left: 192 + 370, top: 194 + 86, labelLeft: -310, labelTop: 40},
  {serialNo: 'GDY20180803320003', name: '3 - Ul. Węglowa', left: 280 + 370 - 20, top: 275 + 83 - 30, labelLeft: -340, labelTop: 5},
  {serialNo: 'GDY20180803320004', name: '4 - Nauta', left: 320 + 365, top: 435 + 75, labelLeft: -340, labelTop: 5},
  {serialNo: 'GDY20180803320005', name: '5 - Dalmor', left: 470 + 357, top: 409 + 75, labelLeft: 40, labelTop: 5},
  {serialNo: 'GDY20181103320006', name: '6 - Bunkier', left: 105 + 377, top: 182 + 86, labelLeft: -340, labelTop: -210},
  {serialNo: 'GDY_07', name: '7 - Nab. Indyjskie', left: 455, top: 145, labelLeft: -340, labelTop: -110}];


const seriesData = (measurementData) => map(measurementData, (data, serialNo) => {
  return ({
    name: devicesNames[serialNo],
    data: data,
  });
});
const serials = ['GDY_00', 'GDY20180803320001', 'GDY20180803320002', 'GDY20180803320003', 'GDY20180803320004', 'GDY20180803320005', 'GDY20181103320006', 'GDY_07'];
const measurements = ['PM10', 'PM25'];
const PUBLIC_DATA_7d = `${BASE_URL}/history/gdy/7d?m=${measurements}&serialNo=${serials}`;
const PUBLIC_DATA_3d = `${BASE_URL}/history/gdy/3d?m=${measurements}&serialNo=${serials}`;
const PUBLIC_DATA_LAST = `${BASE_URL}/last/gdy/${serials}?m=PM10,PM25`;

function GDY_App() {
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [data7d, setData7d] = useState({});
  const [data3d, setData3d] = useState({});
  const [dataLast, setDataLast] = useState({});
  const en = window.location.href.includes('lang=en');

  useEffect(() => {
    if (!window.location.href.includes('lang=en')) {
      Highcharts.setOptions({
        lang: {
          loading: 'Pobieram dane...',
          shortMonths: [
            'Styczeń', 'Luty', 'Marzec', 'Kwiecień',
            'Maj', 'Czerwiec', 'Lipiec', 'Sierpień',
            'Wrzesień', 'Październik', 'Listopad', 'Grudzień'
          ],
          months: [
            'Styczeń', 'Luty', 'Marzec', 'Kwiecień',
            'Maj', 'Czerwiec', 'Lipiec', 'Sierpień',
            'Wrzesień', 'Październik', 'Listopad', 'Grudzień'
          ],
          weekdays: [
            'Niedziela', 'Pon.', 'Wtorek', 'Środa', 'Czwartek',
            'Piątek', 'Sobota', 'Niedziela'
          ]
        }
      });
    }
    console.log(PUBLIC_DATA_LAST);

    fetch(PUBLIC_DATA_LAST).then(response => {
      response.json().then(result => setDataLast(result));
    }).catch(error => console.error(error));

    fetch(PUBLIC_DATA_3d).then(response => {
      response.json().then(result => setData3d(result));
    }).catch(error => console.error(error));
    fetch(PUBLIC_DATA_7d).then(response => {
      response.json().then(result => setData7d(result));
    }).catch(error => console.error(error));

  }, []);

  const safeReadValue = (serialNo, m) => {
    if (dataLast[serialNo] && dataLast[serialNo][m]) {
      return dataLast[serialNo][m][1];
    } else {
      return null;
    }
  };
  const safeReadTime = (serialNo, m) => {
    if (dataLast[serialNo] && dataLast[serialNo][m]) {
      return dataLast[serialNo][m][0];
    } else {
      return new Date().getTime();
    }
  };
  const onDeviceClick = serialNo => setSelectedDevice(serialNo);
  // const lastPM10Measurement = data3d?.PM10 && data3d?.PM10[selectedDevice] && data3d?.PM10[selectedDevice].length > 0 && data3d?.PM10[selectedDevice][0][1];
  const makeLabel = d => {
    let label = d.name;
    // label += " " + data3d?.PM10 && data3d?.PM10[d.serialNo] && data3d?.PM10[d.serialNo].length > 0 && data3d?.PM10[d.serialNo][data3d?.PM10[d.serialNo].length - 1][1];
    // label += " ug/m3";
    return label;
  };

  return (
    <Box textAlign={'center'}>
      <Typography
        color={PORT_GDYNIA_MAIN_COLOR}
        fontWeight={'bold'}
        variant={'h5'}>{en ? 'Air quality monitoring points' : 'Punkty monitoringu jakości powietrza'}</Typography>
      <br/>

      <Box mb={10} display={'flex'} flexWrap={'wrap'} alignItems={'center'} justifyContent={'center'}>

        <Box position={'relative'} width={1380} height={744} sx={{backgroundImage: `url(${Mapka})`}}>
          {devices.map(d =>
            <DeviceMarker
              pm10={safeReadValue(d.serialNo, 'PM10')}
              pm25={safeReadValue(d.serialNo, 'PM25')}
              timestamp={safeReadTime(d.serialNo, 'PM10')}

              marginTop={d.serialNo === 'GDY20180803320002' ? -4 : 0}
              marginLeft={d.serialNo === 'GDY20180803320002' ? 5 : -10}
              label={makeLabel(d)}
              labelLeft={d.labelLeft}
              labelTop={d.labelTop}
              key={d.serialNo} left={d.left} top={d.top} onClick={() => onDeviceClick(d.serialNo)}
            />
          )}
        </Box>
      </Box>

      <br/><br/>

      <AnalyticChart
        measurement={'PM10'}
        seriesList={seriesData(data3d.PM10)}
        title={en ? 'Averaged PM10 Measurement (1h) - for the Last 3 Days' : 'Pomiar uśredniony PM10 (1h) - za ostatnie 3 dni'}
      />
      <br/><br/>
      <AnalyticChart
        measurement={'PM2.5'}
        seriesList={seriesData(data3d.PM25)}
        title={en ? 'Averaged PM2.5 Measurement (1h) - for the Last 3 Days' : 'Pomiar uśredniony PM2.5 (1h) - za ostatnie 3 dni'}
      />
      <br/><br/>
      <AnalyticChart
        columns
        title={en ? 'Averaged PM10 Measurement (24h) - for the Last 7 Days' : 'Pomiar uśredniony PM10 (24h) - za ostatnie 7 dni'}
        measurement={'PM10'}
        seriesList={seriesData(data7d.PM10)}/>
      <br/><br/>

      <AnalyticChart columns
                     title={en ? 'Averaged PM2.5 Measurement (24h) - for the Last 7 Days' : 'Pomiar uśredniony PM2.5 (24h) - za ostatnie 7 dni'}
                     seriesList={seriesData(data7d.PM25)}
                     measurement={'PM2.5'}
      />
      <br/><br/>

    </Box>
  );
}

export default GDY_App;
